/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 *
 ********************************************************************!*/

import { fetchCloudRun } from "../Helper";

export const addOrganization = async (
  organizationName: string
): Promise<void> => {
  await fetchCloudRun(
    process.env.VUE_APP_BASE_URL + "/admin/organizations",
    "POST",
    {},
    {
      name: organizationName,
    }
  );
};
